<style lang="postcss">
  :global(.m-fadeOut) {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }
  :global(.m-fadeIn) {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
  :global(.clicked) {
    flex: 0 0 auto !important;
  }
  .withTransition {
    flex: 0.3 0 auto;
    transition: 500ms ease-in;
  }
</style>

<div id="walletContainer" class="flex justify-start items-center withTransition relative w-3 clicked m-fadeOut">
  <div on:click={addCoin} class="text-lg btn btn-sm btn-outline flex justify-between" style='color: rgb(218, 156, 251); border-color: rgb(218, 156, 251)'>
    {formatter.format($walletData['neonAmount'])} NEON
    <Neon className='-mr-3' style='height: inherit;' />
  </div>
</div>

<script>
  import { connected } from './../stores.js';
  import { walletData } from './../stores.js';
  import {location} from 'svelte-spa-router'
  import Neon from './../svgs/neon.svelte';

  // <------  Formatter ------>

  var formatter = Intl.NumberFormat('en', { notation: 'compact' });

  // <------ Add Coin ------->
  async function addCoin() {
    const tokenAddress = '0xeef087A97A93B3C0B8ab2dACc9295e86B99e70f3';
    const tokenSymbol = 'TUT';
    const tokenDecimals = 18;
    const tokenImage = 'http://placekitten.com/200/300';

    // wasAdded is a boolean. Like any RPC method, an error may be thrown.
    const wasAdded = await ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20', // Initially only supports ERC20, but eventually more!
        options: {
          address: tokenAddress, // The address that the token is at.
          symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
          decimals: tokenDecimals, // The number of decimals in the token
          image: tokenImage, // A string url of the token logo
        },
      },
    });
  }
  // <------ Show Wallet   ------->

  $: ($connected && $walletData['sinuAmount'] && ($location != '/Index' && $location != '/') && showWallet());
  $: ($connected == false && ($location == '/Index' || $location == '/') && hideWallet());
  $: ($connected && $walletData['sinuAmount'] && ($location == '/Index' || $location == '/') && hideWallet());

  function showWallet() {
    if (document.getElementById('walletContainer') != null) {
      document.getElementById('walletContainer').classList.add("m-fadeIn");
      document.getElementById('walletContainer').classList.remove("clicked");
    }
  }

  function hideWallet() {
    if (document.getElementById('walletContainer') != null) {
      document.getElementById('walletContainer').classList.remove("m-fadeIn");
      document.getElementById('walletContainer').classList.add("m-fadeOut");
      document.getElementById('walletContainer').classList.add('clicked');
    }
  }
</script>